<template>
  <el-tabs v-model="tabsName" @tab-click="gotoOtherPage">
    <el-tab-pane v-for="(item,index) in list" :key="index" :label="item.name" :name="item.name">
    </el-tab-pane>
  </el-tabs>
</template>

<script type="text/ecmascript-6">
import { tool } from "../common/js/tool.js";
export default {
  data() {
    return {
      tabsName: "",
      list: [
        { name: "人员报警查询", url: "/data/ws1-person-warning" }, //报警查询
        { name: "工作超时报警", url: "/data/ws2-work-timeout" },
        { name: "区域超员告警", url: "/data/ws3-area-full-people" },
        { name: "禁入区域告警", url: "/data/ws4-restricted-warning" },
        { name: "工种冲突报警", url: "/data/ws5-work-type-repeat" },
        { name: "人员静止查询", url: "/data/ws6-person-static" },
        { name: "基站电压低", url: "/data/ws7-station-voltage-low" },
        { name: "基站不在线", url: "/data/ws8-station-offline" },
        { name: "卡电压低告警", url: "/data/ws9-card-voltage-low" },
        { name: "传感器报警", url: "/data/ws10-sensor-warning" }
      ]
    };
  },

  props: ["name"],

  computed: {},

  created() {},

  updated() {
    this.tabsName = this.name;
  },

  methods: {
    gotoOtherPage() {
      // let hash = window.location.hash.replace("#", "");
      let hash = this.$route.query.u;
      // console.log(hash);
      // console.log(this.$route.query.u);
      for (let i = 0; i < this.list.length; i++) {
        if (this.tabsName == this.list[i].name) {
          console.log(this.list[i].url);
          this.$router.push({
            path: this.list[i].url,
            query: { u: "/data/ws1-person-warning" }
          });
          break;
        }
      }
    }
  },

  components: {}
};
</script>

<style lang="less" rel="stylesheet/less">
@import "../common/less/variable.less";
</style>
